export default __webpack_public_path__ + "static/media/KK_logo_keskitetty_eng_rgb_black.5386aed1.jpg";